export function loadFareHarborScript() {
  let isFound = false;
  const scripts = document.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; ++i) {
    if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("fareharbor.com")) {
      isFound = true;
    }
  }

  if (!isFound) {
    const dynamicScripts = ["https://fareharbor.com/embeds/api/v1/?autolightframe=yes"];
    for (const dynamicScript of dynamicScripts) {
      const node = document.createElement('script');
      node.src = dynamicScript;
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('body')[0].appendChild(node);
    }
  }
}
